import { render, staticRenderFns } from "./NewFormCourse.html?vue&type=template&id=2c2705c2&scoped=true&"
import script from "./NewFormCourse.vue?vue&type=script&lang=js&"
export * from "./NewFormCourse.vue?vue&type=script&lang=js&"
import style0 from "./NewFormCourse.scss?vue&type=style&index=0&id=2c2705c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2705c2",
  null
  
)

export default component.exports